/* eslint-disable */
// export const appHomeUrl = "http://localhost:5000";
//offshore
// export const appHomeUrl = "https://dev.falcon.kyybaapps.com";
//onshore
//dev
// export const appHomeUrl = "https://falcon-dev.ehs.mass.gov/clientcomm";
//QA
//export const appHomeUrl = "https://falcon-qa.ehs.mass.gov/clientcomm";
//test
//export const appHomeUrl = "https://falcon-test.ehs.mass.gov/clientcomm";
//PROD
export const appHomeUrl = "https://falcon.ehs.mass.gov/clientcomm";



export const msalConfig = {
    auth: {
        //DEV
        // clientId: "632ad36c-aeea-4cb7-85ab-8d4691b938a2",
        //QA
        //clientId: "cc1b5e63-3585-4cfe-9fb7-5ed627db4939",
        //test
        // clientId: "44327953-b778-4885-b8bc-e94aa9014baa",
        //PROD
        clientId: "e2281eb3-4349-4386-a499-91ff8ba91fb8",
        authority: "https://login.microsoftonline.com/3e861d16-48b7-4a0e-9806-8c04d81b7b2a",
        knownAuthorities: ["massgov.onmicrosoft.com"],
        redirectUri: appHomeUrl,
        postLogoutRedirectUri: appHomeUrl,
        // response_type: "id_token",
        // prompt: "login",
    }
};

// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const loginRequest = {
    scopes: ['openid', 'profile', 'user.read', 'email'],
    extraQueryParameters: {},
    authority: "https://login.microsoftonline.com/3e861d16-48b7-4a0e-9806-8c04d81b7b2a",
};


export const postLogoutRedirectUri = {
    redirectUri: `${appHomeUrl}/login`
}

export const config = {
    //DEV
    // 'API_URL': "https://dta-falconapi-dev.ehs.mass.gov/falcon",
    //QA
    //'API_URL': "https://dta-falconapi-qa.ehs.mass.gov/falcon",
    //TEST
    //'API_URL': "https://dta-falconapi-test.ehs.mass.gov/falcon",
    //PROD
    'API_URL': "https://dta-falconapi-prod.ehs.mass.gov/falcon",
    //offshore
    // 'API_URL' : "https://api.qa.falcon.kyybaapps.com/falcon",
    'CAMPAIGN_STATUS': [{ key: 'All', value: 0 }, { key: 'Processed', value: 206 }, { key: 'Scheduled', value: 203 }, { key: 'Processing', value: 202 }, { key: 'Cancelled', value: 205 }],
    'CHANNEL_LIST': [
        { key: "All Communication Channels", value: "all" },
        { key: "SMS", value: "sms" },
        { key: "Email", value: "email" },
        // {key: "Voice", value: "voice"},
    ]
}

export const origin = "*"

export const roles = {
    "FBSUSR": "Business User",
    "FAGADN": "Agency Admin",
    "FPRADN": "Product Admin"
}

export const statusList = [
    { key: "all", value: "All" },
    { key: "success", value: "Success" },
    { key: "failure", value: "Failure" },
];